export interface AssumptionsApprovalState {
  status: "not_loaded" | "loading" | "loaded" | "error";
  hardBlockers: number;
  warningIds: string[];
  acceptedWarningIds: string[];
  reviewNote: string;
}

export function canApproveAfterAssumptions(
  automaticChecksReady: boolean,
  assumptions: AssumptionsApprovalState,
): boolean {
  const warningsAccepted = assumptions.warningIds.length === 0 || (
    assumptions.reviewNote.trim().length > 0
    && assumptions.warningIds.every((id) => assumptions.acceptedWarningIds.includes(id))
    && assumptions.acceptedWarningIds.every((id) => assumptions.warningIds.includes(id))
  );
  return automaticChecksReady
    && assumptions.status === "loaded"
    && assumptions.hardBlockers === 0
    && warningsAccepted;
}
